import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, InputLabel, IconButton, Divider, Grid, Paper, Toolbar, CircularProgress } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, PayOffListActions} from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    headerTitle: {
        fontWeight: 'bold',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const payOffListSelector = (state) => state.PayOffList;
const IdentitySelector = (state) => state.Identity;

// 精算日別画面
const PayOffDaily = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const payOffListActions = bindActionCreators(PayOffListActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { listDaily, nowWainting } = useSelector(payOffListSelector);
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    const listDefinition = {
        columns: [
            {
                // 日付
                title: <FormattedMessage id="Adjustment.Date" />,
                field: 'nengappi',
                type: 'date',
                filtering: true
            },
            {
                // 支払額
                title: <FormattedMessage id="Adjustment.AmountPaid" />,
                field: 'payment_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
            {
                // 請求額
                title: <FormattedMessage id="Adjustment.AmountBilled" />,
                field: 'billing_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
        ]
    };

    /**
     *
     * 戻る押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 詳細ボタン押下時の処理
     *
     * @param dtl 選択された行のデータ
     */
    const onDetailClick = (dtl) => {
        const dt = new Date(dtl.nengappi);
        var nengappi = dt.getFullYear() + '/' + ("0" + (dt.getMonth() + 1)).slice(-2) + '/' + ("0" + dt.getDate()).slice(-2);
        // 精算詳細一覧を取得
        payOffListActions.listPayOffListsDetail(token, dtl.nengetsu, props.fixedDt, dtl.merchant_type, dtl.merchant_id, nengappi)
            .then(data => {
                props.onDetail(dtl, nengappi);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    if (listDaily == null || listDaily.length == 0) {
        return <div>データが存在しません。</div>;
    }

    const dt = new Date(props.fixedDt);
    var fixDt = dt.getFullYear() + '年' + ("0" + (dt.getMonth() + 1)).slice(-2) + '月' + ("0" + dt.getDate()).slice(-2) + '日';

    var startDt = '';
    var endDt = '';
    if (props.paymentCycle == 1) {
        // 月１回
        // 対象期間：1日～末日　確定日：翌月4日
        if (dt.getDate() == 4) {
            // 1カ月前の1日
            let sDt = new Date(dt.getFullYear(), dt.getMonth() - 1, 1);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 1カ月前の末日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 0);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }

    } else if (props.paymentCycle == 2) {
        // 月２回
        // 対象期間：1日～15日　確定日：当月19日
        if (dt.getDate() == 19) {
            // 当月の1日
            let sDt = new Date(dt.getFullYear(), dt.getMonth(), 1);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 当月の15日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 15);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }
        // 対象期間：16日～末日　確定日：翌月4日
        else if (dt.getDate() == 4) {
            // 1カ月前の16日
            let sDt = new Date(dt.getFullYear(), dt.getMonth() - 1, 16);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 1カ月前の末日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 0);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }
    } else if (props.paymentCycle == 3) {
        // 月４回
        // 対象期間：1日～8日　確定日　当月12日
        if (dt.getDate() == 12) {
            // 当月の1日
            let sDt = new Date(dt.getFullYear(), dt.getMonth(), 1);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 当月の8日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 8);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }
        // 対象期間： 9日～15日　確定日：当月19日
        else if (dt.getDate() == 19) {
            // 当月の9日
            let sDt = new Date(dt.getFullYear(), dt.getMonth(), 9);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 当月の15日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 15);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }
        // 対象期間：16日～22日　確定日：当月26日
        else if (dt.getDate() == 26) {
            // 当月の16日
            let sDt = new Date(dt.getFullYear(), dt.getMonth(), 16);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 当月の22日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 22);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }
        // 対象期間：23日～末日　確定日：翌月4日
        else if (dt.getDate() == 4) {
            // 1カ月前の23日
            let sDt = new Date(dt.getFullYear(), dt.getMonth() - 1, 23);
            startDt = sDt.getFullYear() + '/' + ("0" + (sDt.getMonth() + 1)).slice(-2) + '/' + ("0" + sDt.getDate()).slice(-2);
            // 1カ月前の末日
            let eDt = new Date(dt.getFullYear(), dt.getMonth(), 0);
            endDt = eDt.getFullYear() + '/' + ("0" + (eDt.getMonth() + 1)).slice(-2) + '/' + ("0" + eDt.getDate()).slice(-2);
        }
    }
    var listTitle = `[${startDt} 00:00 ～ ${endDt} 23:59]`;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Adjustment.SettlementByDate" />}</Typography>
                    </div>
                </Toolbar>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.MerchantName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{props.merchantName}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.MerchantType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{props.merchantType}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.FixedDate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{fixDt}</InputLabel>
                    </Grid>
                </Grid>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{listTitle}</Typography>}
                columns={listDefinition.columns}
                data={listDaily}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            return (
                                <div></div>
                            )
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PayOffDaily);
